"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.silent = exports.adaptiveDirection = exports.overflow = exports.offset = exports.arrow = exports.createPopper = void 0;
const arrow_1 = __importDefault(require("@popperjs/core/lib/modifiers/arrow"));
const hide_1 = __importDefault(require("@popperjs/core/lib/modifiers/hide"));
const offset_1 = __importDefault(require("@popperjs/core/lib/modifiers/offset"));
const preventOverflow_1 = __importDefault(require("@popperjs/core/lib/modifiers/preventOverflow"));
const popper_lite_1 = require("@popperjs/core/lib/popper-lite");
require("./tooltip.types");
const utils_1 = require("./utils");
exports.createPopper = (0, popper_lite_1.popperGenerator)({
    defaultModifiers: [
        ...popper_lite_1.defaultModifiers,
        preventOverflow_1.default,
        offset_1.default,
        arrow_1.default,
        hide_1.default,
    ],
});
exports.arrow = {
    name: 'arrow',
    options: {
        padding: 2,
    },
};
exports.offset = {
    name: 'offset',
    options: {
        offset: [0, utils_1.padding],
    },
};
const overflow = ($container) => ({
    name: 'preventOverflow',
    options: {
        boundary: $container,
        altAxis: true,
        padding: 16,
    },
});
exports.overflow = overflow;
const adaptiveDirection = ($container, direction) => ({
    name: 'direction',
    enabled: true,
    phase: 'beforeRead',
    fn({ state }) {
        state.placement = (0, utils_1.fit)({
            $container,
            $control: state.elements.reference,
            $tooltip: state.elements.popper,
            direction,
        });
    },
});
exports.adaptiveDirection = adaptiveDirection;
exports.silent = [
    exports.offset,
    { name: 'eventListeners', enabled: false },
    { name: 'computeStyles', enabled: false },
];
